import { dispatchClaimsAPICall } from "./apiCall.js";
import { NotificationManager } from "react-notifications";
import { panelUpdateStrings } from "./panelsSlice.js";


export function sendAction(hwaddr, networkId, action, data) {
    return dispatch => dispatch(dispatchClaimsAPICall(`/v2/sites/${hwaddr}/panel/${networkId}/buttons`, { action, data }));
}
export function setPanelstrings(hwaddr, networkId, panelName, panelCompanyName, panelSiteName, panelPhoneNumber) {
    return async (dispatch) => {
        try {
            await dispatch(
                dispatchClaimsAPICall(`/v2/sites/${hwaddr}/panel/${networkId}/strings`, { panelName, panelCompanyName, panelSiteName, panelPhoneNumber })
            );

            dispatch(panelUpdateStrings(hwaddr, networkId, panelName, panelCompanyName, panelSiteName, panelPhoneNumber));
        }
        catch (err) {
            NotificationManager.error(err.toString());
        }

    };
}
